
//Customers data page where all data stored in object form

// import Casestudy_1 from "./Casestudy_1";
// import Casestudy_2  from "./Casestudy_2"

const CustomerData= [
   {id:1,
    img:"https://global-uploads.webflow.com/5fecd74b489ca969cf5a3848/609b04d816f2a5e189b6b67a_Amerifirst-jpg-1024x309-p-500.jpeg",
    detail:"AmeriFirst - Scaling a Compliant Social Media Program Across Regional Branches with Lately.ai",
    link:"./Casestudy_1.jsx"
},
{id:2,
    img:"https://global-uploads.webflow.com/5fecd74b489ca969cf5a3848/60a413bac40f5180700398c9_Tamarin_Health_Logo-p-800.jpeg",
    detail:"Tamarin Health - Amplifying an Employee Advocacy Campaign Across All Social Media Platforms with Lately.ai",
    link:"./Casestudy_2.jsx"
},
{id:3,
    img:"https://global-uploads.webflow.com/5fecd74b489ca969cf5a3848/60c76ba1fd9ca50e087999fd_NEW%20Revry%20Logo-p-500.png",
    detail:"Revry - Boosting Organic Reach and Amplifying Brand Awareness with Lately.ai",
    link:"./Casestudy_1.jsx"
},
{id:4,
    img:"https://global-uploads.webflow.com/5fecd74b489ca969cf5a3848/5fee40109eefd2f4879aba22_supportingstrategies_logo.jpg",
    detail:"Outsourced book keeping and back office services firm uses Lately's social selling to manage social media across 90 locations in the U.S. and double website traffic.",
    link:"./Casestudy_1.jsx"
},
{id:5,
    img:"https://global-uploads.webflow.com/5fecd74b489ca969cf5a3848/5fee44300c6503a346bf68c2_SCM.png",
    detail:"Supply chain consulting firm specializing in SAP",
    link:"./Casestudy_1.jsx"
},
{id:6,
    img:"https://global-uploads.webflow.com/5fecd74b489ca969cf5a3848/5fee3945acad01768be94d21_ValueGraphics-p-500.png",
    detail:"Consumer marketing agency, researcher, and public speaker on predicting and influencing behavior.",
    link:"./Casestudy_1.jsx"
},
{id:7,
    img:"https://global-uploads.webflow.com/5fecd74b489ca969cf5a3848/5fee39e0e7b951b4f6a39ade_dynasty-icon.png",
    detail:"Dynasty TV uses Lately's parent-child accounts to keep channel switching rockstars organized.",
    link:"./Casestudy_1.jsx"
},
{id:8,
    img:"https://global-uploads.webflow.com/5fecd74b489ca969cf5a3848/5fee42136e81461335c60357_Fenlason.png",
    detail:"National non-profit uses Lately to keep social media messaging consistent, organized and more efficient.",
    link:"./Casestudy_1.jsx"
}

]
export default CustomerData